import { Controller } from "stimulus"

/**
 * Controls the payroll provider form, showing the connection settings
 * section that matches the selected provider type.
 */
export default class extends Controller {
  static targets = ["typeSelect", "paycorSection"]

  connect() {
    this.toggleSections()
  }

  typeChanged() {
    this.toggleSections()
  }

  toggleSections() {
    const providerType = this.typeSelectTarget.value
    this.paycorSectionTarget.hidden = providerType !== "paycor"
  }
}
